import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { RadioCreditTypesComponent } from '@ui/components/radio-credit-types/radio-credit-types.component';

@Component({
  selector: 'wsb-credits-alert',
  templateUrl: './credits-alert.component.html',
  styleUrls: ['./credits-alert.component.scss'],
  standalone: false
})
export class CreditsAlertComponent implements OnInit {
  @ViewChild('smsType') smsType: RadioCreditTypesComponent;
  @Input() alert: UntypedFormGroup;
  @Input() alertNr: number;
  @Output() atLeastOneNotifyType: EventEmitter<any> = new EventEmitter();

  conditionalFormControls = ['alertLimit', 'notificationMobileNumber', 'notificationEmail', 'smsType', 'creditType'];
  hasMoreThanOneCreditType = true;
  typologieCurrencyAlerteCredit = false;

  constructor(@Inject(DOCUMENT) private document: Document, private translateService: TranslateService) {}

  ngOnInit(): void {
    this.translateService
      .get('common_currency')
      .subscribe(label => (this.typologieCurrencyAlerteCredit = label && label !== '' && label !== 'common_currency'));

    this.alert.get('notifyBySms').valueChanges.subscribe(() => {
      this.validateForm('notificationMobileNumber', 'notify-by-sms' + this.alertNr);
      this.atLeastOneNotifyType.emit(true);
    });
    this.alert.get('notifyByEmail').valueChanges.subscribe(() => {
      this.validateForm('notificationEmail', 'notify-by-email' + this.alertNr);
      this.atLeastOneNotifyType.emit(true);
    });
    this.alert.get('enabled').valueChanges.subscribe(() => {
      this.conditionalFormControls.forEach(fc => {
        this.alert.get(fc).updateValueAndValidity({ onlySelf: true });
      });
    });
  }

  validateForm(formControl: string, elementFocus?: string): void {
    if (formControl === 'notificationMobileNumber') {
      this.alert.get(formControl).setValidators(Validators.pattern(/^(\+)?[0-9]{5,15}$/));
      this.alert.get(formControl).updateValueAndValidity({ onlySelf: true });
    } else {
      this.alert.get(formControl).updateValueAndValidity({ onlySelf: true });
    }
    if (elementFocus) {
      const input = this.document.getElementById(elementFocus);
      input.click();
      input.focus();
      input.blur();
    }
  }

  onCreditTypes(credits: any[]) {
    if (credits.length === 1) {
      this.hasMoreThanOneCreditType = false;
      if (!this.alert.get('smsType').value) {
        this.alert.patchValue({ smsType: credits[0].value });
      }
    }
  }
}
